class KovFormGroup {

  constructor($scope){
    'ngInject';
    this.$scope = $scope;
  }

  hasErrors() {
    return this.sErrors.length > 0 || this.validationErrors.length > 0 || this.requiredError || this.patternError || this.minMaxError;
  }

  needsAttention() {
    return !this.isTyping && (this.sEditMode || this.sSubmitAttempted || this.dirty);
  }

  $onInit() {
    if(!this.sErrors) {
      this.sErrors = [];
    }
    if(!this.sWarnings) {
      this.sWarnings = [];
    }
    this.validationErrors = [];
    this.errors = {};

    if(!this.sLabel) {
      this.sLabel = '(no label)';
      this.sLabelWidth = 0;
      this.sInputWidth = 12;
    } else {
      if(!this.sInputWidth || this.sInputWidth > 11 || this.sInputWidth < 1) {
        if(!this.sLabelWidth || this.sLabelWidth > 11 || this.sLabelWidth < 1) {
          this.sLabelWidth = 4;
          this.sInputWidth = 8;
        } else {
          this.sInputWidth = 12 - this.sLabelWidth;
        }
      } else if(!this.sLabelWidth || this.sLabelWidth > 12 - this.sInputWidth || this.sLabelWidth < 1) {
        this.sLabelWidth = 12 - this.sInputWidth;
      }
    }

    let article = 'De';
    if(this.sArticle) {
      article = this.sArticle;
    }
    if(this.sArticle === false) {
      article = null;
    }
    this.subject = (article ? article + ' ' : '') + this.sLabel.toLowerCase();

    this.$scope.$on('kovFormElemLeft', (event) => {
      this.isTyping = false;
      this.dirty = true;
      event.stopPropagation();
    });

    this.$scope.$on('kovFormElemStartTyping', (event) => {
      this.isTyping = true;
      // console.log('user starts typing in ', this.sLabel);
      event.stopPropagation();
    });

    this.$scope.$on('kovFormElemStopTyping', (event) => {
      this.isTyping = false;
      // console.log('got stop typing event for ', this.sLabel);
      event.stopPropagation();
    });

    this.$scope.$on('kovFormElemChanged', (event, payload) => {
      if(!payload.onInitPhase) {
        this.dirty = true;
        console.log(this.sLabel, ' is now changed to ', payload);
      }
      const newErrors = {};
      let changed = payload.onInitPhase;
      this.requiredError = false;
      this.patternError = false;
      this.minMaxError = false;
      this.validationErrors = [];
      payload.errors.forEach(error => {
        newErrors[error.code] = true;
        if(!this.errors[error.code]) {
          changed = true;
        }
        if(error.code === 'required') {
          this.requiredError = error.message || this.subject + ' is verplicht.';
        } else if(error.code === 'pattern') {
          this.patternError = error.message || 'Het formaat van ' + this.subject.toLowerCase() + ' is ongeldig.';
        } else if(error.code === 'pattern.date') {
          this.patternError = error.message || this.subject + ' is geen geldige datum.';
        } else if(error.code === 'min.value') {
          this.minMaxError = error.message || this.subject + ' moet groter zijn dan ' + error.minValue + (error.maxValue ? ' en kleiner dan ' + error.maxValue : '') + '.';
        } else if(error.code === 'max.value') {
          this.minMaxError = error.message || this.subject + ' moet kleiner zijn dan ' + error.maxValue + '.';
        } else if(error.code === 'min.length') {
          this.minMaxError = error.message || this.subject + ' moet langer dan ' + error.minLength + (error.maxLength ? ' en korter dan ' + error.maxLength : '') + ' karakters zijn.';
        } else if(error.code === 'max.length') {
          this.minMaxError = error.message || this.subject + ' moet korter dan ' + error.maxLength + ' karakters zijn.';
        } else {
          this.validationErrors.push(error);
        }
      });
      Object.keys(this.errors).forEach(error => {
        if(!newErrors[error]) {
          changed = true;
        }
      });
      if(changed) {
        this.$scope.$emit('onErrorsChanged', {
          key: this.sKey ? this.sKey : (this.sLabel ? this.sLabel.toLowerCase().replace(' ', '_') : makeid()),
          errors: Object.keys(newErrors)
        });
      }
      this.errors = newErrors;
      this.isTyping = false;
      event.stopPropagation();
    });
  }
};

function makeid() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 5; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

module.exports = {
  template: require('./kovFormGroup.html'),
  controllerAs: 'ctrl',
  controller: KovFormGroup,
  transclude: true,
  bindings: {
    sLabel: '@',
    sKey: '@',
    sHelpText: '@',
    sArticle: '@',
    sAlignLabelRight: '<',
    sLabelWidth: '@',
    sInputWidth: '@',
    sRequired: '<',
    sSubmitAttempted: '<',
    sEditMode: '<',
    sErrors: '<',
    sWarnings: '<'
  }
};
